export default __webpack_public_path__ + "static/media/Declaration of Independence_12.1ee41a05.jpg";